// caiet SEC-08, UC12-02: the session expires after a stretch of inactivity, and
// a request a timer sends (the alerts badge, a dashboard re-reading itself, the
// MConnect events list) is not the person acting. What tells the two apart is
// whether the person gave any input shortly before the request left; loading
// the page counts as such an input (docs/shape-ops-session-inactivity.md §4).
const INPUT_WINDOW_MS = 10_000;

// Listened to on the capture phase, so a component that stops an event still
// counts. A pointer that only moves is left out: browsers also report a move
// when the content shifts under a cursor nobody touched.
const INPUT_EVENTS = ['pointerdown', 'keydown', 'wheel', 'touchstart'] as const;
// The window's own: coming back to the tab, going back or forward in history.
const WINDOW_EVENTS = ['focus', 'popstate'] as const;

let lastInputAt = Date.now();

function noteInput(): void {
  lastInputAt = Date.now();
}

for (const type of INPUT_EVENTS) {
  window.addEventListener(type, noteInput, { capture: true, passive: true });
}
for (const type of WINDOW_EVENTS) {
  window.addEventListener(type, noteInput, { passive: true });
}

export function sentWithoutInput(): boolean {
  return Date.now() - lastInputAt > INPUT_WINDOW_MS;
}
